import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = createKubbApiClient('fragments-api');

export default axiosClient;
